<h2 class="titleDel" mat-dialog-title>{{'MAPP-FBS-SET-AVAILABLE-FACILITY.TITLE' | translate}}</h2>
<mat-dialog-content>
    {{'MAPP-FBS-SET-AVAILABLE-FACILITY.TEXT' | translate}}
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button   mat-raised-button  (click)="close()">{{'MAPP-FBS-SET-AVAILABLE-FACILITY.CANCEL' | translate}}</button>
    <button  mat-raised-button color="primary" (click)="confirm()">{{'MAPP-FBS-SET-AVAILABLE-FACILITY.CONFIRM' | translate}}</button>
</mat-dialog-actions>
<empusa-microapp-fbs-spinner *ngIf="loading" overlay="true"></empusa-microapp-fbs-spinner>